import { defineStore } from 'pinia'

export const useGeneralStore = defineStore('general', {
	state: () => ({
		screen: 0,
		showTopNotification: false,
		visibleMobileNavi: false
	}),

	actions: {
		setScreen(width: number) {
			this.screen = width
		},

		setShowTopNotification(show: boolean) {
			this.showTopNotification = show
		},

		updateMobileNavi(show: boolean) {
			this.visibleMobileNavi = show
		},

    toggleMobileNavi() {
      this.visibleMobileNavi = !this.visibleMobileNavi
    }
	}
})
